import React from 'react';
import { connect } from 'react-redux';

import HeaderPopup from '../../components/header-popup/header-popup';
import logo from '../../assets/food-on-train-logo.png';
import Arrow from '../../assets/icon-back-arrow.svg';


import './header.style.css';
import { ToggleEmptyCartPop, ToggleExitPopUp } from '../../redux/cart/cart.action';
import { createStructuredSelector } from 'reselect';
import { selectCartItemsCount, selectExitPopUp } from '../../redux/cart/cart.selector';

class header extends React.Component {

    handleOnClick = () => {
        if (this.props.cartCount > 0) {
            this.props.ToggleEmptyPop('1');
        } else {
            this.props.ToggleExitPop();
        }
    }
    render() {
        const { ToggleExitPop, exitPopupHidden } = this.props;
        return (
            <div className="header-container">
                {exitPopupHidden === false &&
                    <HeaderPopup closePopup={ToggleExitPop} />
                }
                <img id="logo" className="logo-img" alt="logo" src={logo}></img>

                <div uk-sticky="true" className="nav-bar">
                    <div>
                        <button className="arrow-button" onClick={() => { this.handleOnClick() }}> <img src={Arrow} className="arrow-img" alt="img"></img></button>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = createStructuredSelector({
    cartCount: selectCartItemsCount,
    exitPopupHidden: selectExitPopUp,
})
const mapDispatchToProps = dispatch => ({
    ToggleEmptyPop: value => dispatch(ToggleEmptyCartPop(value)),
    ToggleExitPop: () => dispatch(ToggleExitPopUp()),
})
export default connect(mapStateToProps, mapDispatchToProps)(header);